<div class="sellerBadge">
  <h1 class="sellerBadge__title vc-title-m" i18n="@@SELLER_BADGES.TITLE">Trusted and Expert Seller Badges</h1>
  ​
  <section class="sellerBadge__section sellerBadge__section--intro">
    <img
      class="sellerBadge__section__photo"
      src="https://assets-images.vestiairecollective.com/cdn-cgi/image/f=auto,w=494,h=311,fit=crop,dpr=2/assets/images/sellerRatingPage/trusted-expert-seller.jpg"
      alt=" "
    />

    <p
      class="sellerBadge__section__paragraph sellerBadge__section__paragraph--intro vc-text-l"
      i18n="@@SELLER_BADGES.INTRO"
    >
      Seller badges are a new way for our most <strong>active</strong> and <strong>trustworthy</strong> sellers to stand
      out on Vestiaire Collective. Increase your seller stats, unlock a
      <span class="sellerBadge__section__paragraph__badge sellerBadge__section__paragraph__badge--trusted">
        <img
          src="https://assets-images.vestiairecollective.com/cdn-cgi/image/f=auto,w=22,h=22,fit=crop,dpr=2/assets/images/sellerRatingPage/badge-trusted-seller.png"
          class="sellerBadge__section__paragraph__badge__icon"
          i18n-alt="@@SELLER_BADGES.ICON_ALT.TRUSTED_SELLER"
          alt="Trusted Seller icon"
        /><span>Trusted Seller</span>
      </span>
      or
      <span class="sellerBadge__section__paragraph__badge sellerBadge__section__paragraph__badge--expert">
        <img
          src="https://assets-images.vestiairecollective.com/cdn-cgi/image/f=auto,w=22,h=22,fit=crop,dpr=2/assets/images/sellerRatingPage/badge-expert-seller.png"
          class="sellerBadge__section__paragraph__badge__icon"
          i18n-alt="@@SELLER_BADGES.ICON_ALT.EXPERT_SELLER"
          alt="Expert Seller Icon"
        /><span>Expert Seller</span>
      </span>
      badge and get rewarded with <strong>exclusive advantages</strong> to boost your visibility and sales.
    </p>
  </section>
  ​
  <section class="sellerBadge__section">
    <h2 class="sellerBadge__section__title vc-title-s" i18n="@@SELLER_BADGES.SECTION_1.TITLE">
      How can I unlock a badge?
    </h2>
    <p
      class="sellerBadge__section__paragraph sellerBadge__section__paragraph--sMargin vc-text-m"
      i18n="@@SELLER_BADGES.SECTION_1.PARAGRAPH_1"
    >
      Badges are awarded to the sellers who sell regularly, ensure their items conform to their descriptions and ship
      quickly.
    </p>
    <p class="sellerBadge__section__paragraph vc-text-m" i18n="@@SELLER_BADGES.SECTION_1.PARAGRAPH_2">
      There are two levels of seller badges: Trusted and Expert. They can be earned based on 3 criteria.
    </p>
    <div class="sellerBadge__section__block vc-importantText">
      <div class="sellerBadge__section__block__badge  sellerBadge__section__block__badge--trusted">
        <img
          src="https://assets-images.vestiairecollective.com/cdn-cgi/image/f=auto,w=56,h=56,fit=crop,dpr=2/assets/images/sellerRatingPage/badge-trusted-seller.png"
          class="sellerBadge__section__block__badge--icon"
          i18n-alt="@@SELLER_BADGES.ICON_ALT.TRUSTED_SELLER"
          alt="Trusted Seller icon"
        />
        <span class="sellerBadge__section__block__label vc-text-l" i18n="@@SELLER_BADGES.TRUSTED_SELLER">
          Trusted Seller
        </span>
      </div>
      <div class="sellerBadge__section__block__badge sellerBadge__section__block__badge--expert">
        <img
          src="https://assets-images.vestiairecollective.com/cdn-cgi/image/f=auto,w=56,h=56,fit=crop,dpr=2/assets/images/sellerRatingPage/badge-expert-seller.png"
          class="sellerBadge__section__block__badge--icon"
          i18n-alt="@@SELLER_BADGES.ICON_ALT.EXPERT_SELLER"
          alt="Expert Seller Icon"
        />
        <span class="sellerBadge__section__block__label vc-text-l" i18n="@@SELLER_BADGES.EXPERT_SELLER">
          Expert Seller
        </span>
      </div>
    </div>
    <table class="sellerBadge__table vc-text-important">
      <tr>
        <th class="sellerBadge__table__hcell ">
          <h3 i18n="@@SELLER_BADGES.SECTION_1.TABLE.TITLE" class="vc-text-l sellerBadge__table__hcell--title">
            Criteria
          </h3>
          <p i18n="@@SELLER_BADGES.SECTION_1.TABLE.SUBTITLE" class="vc-text-s sellerBadge__table__hcell--subtitle">
            (Over the Last 6 months)
          </p>
        </th>
        <th class="sellerBadge__table__hcell">
          <vc-sprite-icons
            name="badge-trusted"
            class="sellerBadge__table__hcell__icon sellerBadge__table__hcell__icon--trusted"
          ></vc-sprite-icons>
        </th>
        <th class="sellerBadge__table__hcell">
          <vc-sprite-icons
            name="badge-expert"
            class="sellerBadge__table__hcell__icon sellerBadge__table__hcell__icon--expert"
          ></vc-sprite-icons>
        </th>
      </tr>
      <tr class="sellerBadge__table__row">
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--criteria"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_1.CELL_1"
        >
          <h4>Volume</h4>
          <p class="vc-text-s">
            Number of items sold in a 4-month rolling period.
          </p>
        </td>
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--trusted vc-text-l"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_1.CELL_2"
        >
          2 items
        </td>
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--expert vc-text-l"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_1.CELL_3"
        >
          5 items
        </td>
      </tr>
      <tr class="sellerBadge__table__row">
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--criteria"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_2.CELL_1"
        >
          <h4>Conformity</h4>
          <p class="vc-text-s">
            Percentage of items sold in a 4-month rolling period which conformed to their description.
          </p>
        </td>
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--trusted vc-text-l"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_2.CELL_2"
        >
          80%
        </td>
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--expert vc-text-l"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_2.CELL_3"
        >
          90%
        </td>
      </tr>
      <tr class="sellerBadge__table__row">
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--criteria"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_3.CELL_1"
        >
          <h4>Shipping</h4>
          <p class="vc-text-s">
            Percentage of items sold in a 4-month rolling period which were shipped in less than 5 days.
          </p>
        </td>
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--trusted vc-text-l"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_3.CELL_2"
        >
          80%
        </td>
        <td
          class="sellerBadge__table__cell sellerBadge__table__cell--expert vc-text-l"
          i18n="@@SELLER_BADGES.SECTION_1.TABLE.LINE_3.CELL_3"
        >
          90%
        </td>
      </tr>
    </table>
  </section>

  <section class="sellerBadge__section">
    <div class="sellerBadge__section__lists__container">
      <h2 class="vc-title-s" i18n="@@SELLER_BADGES.SECTION_LISTS.TITLE">
        Tips
      </h2>
      <ul class="sellerBadge__section__tips__list">
        <li class="sellerBadge__section__tips__list__item">
          <h4 i18n="@@SELLER_BADGES.SECTION_LISTS.TITLE_1">Volume - How to Sell More</h4>
          <ul>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_1" class="sellerBadge__tips__list__item vc-text-m">
              Pictures help tell your item's story. Make sure you add plenty, and that they are clear and well-lit
            </li>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_2" class="sellerBadge__tips__list__item vc-text-m">
              The more details you include in your description, the better your chances of a fast sale
            </li>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_3" class="sellerBadge__tips__list__item vc-text-m">
              Regular price drops will make your item more visible to the community
            </li>
          </ul>
          <h4 i18n="@@SELLER_BADGES.SECTION_LISTS.TITLE_2">Conformity - How to Sell Better</h4>
          <ul>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_4" class="sellerBadge__tips__list__item vc-text-m">
              Always ensure condition, description and pictures are honest
            </li>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_5" class="sellerBadge__tips__list__item vc-text-m">
              All items must be authentic
            </li>
          </ul>
        </li>
        <li class="sellerBadge__section__tips__list__item">
          <h4 i18n="@@SELLER_BADGES.SECTION_LISTS.TITLE_3">Shipping - How to Ship Like A Pro</h4>
          <ul class="sellerBadge__section__tips__list__item__last">
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_6" class="sellerBadge__tips__list__item vc-text-m">
              Ship everything as soon as you can
            </li>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_7" class="sellerBadge__tips__list__item vc-text-m">
              Regularly check the items you're selling, and remove the ones you don't want to sell to avoid
              cancellations
            </li>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_8" class="sellerBadge__tips__list__item vc-text-m">
              Remember to activate Holiday Mode when you’re away so that you don't receive orders that you can’t ship
            </li>
            <li i18n="@@SELLER_BADGES.SECTION_LISTS.TIPS_9" class="sellerBadge__tips__list__item vc-text-m">
              Check that your notifications are activated to make sure you’re notified of sales and delivery times ASAP
            </li>
          </ul>
        </li>
      </ul>
    </div>
    <vc-ref
      i18n-resource="@@SELLER_BADGES.SECTION_1.BUTTON.LINK"
      resource="/action?type=sellerRatingStats"
      [anchor]="true"
      extraClass="vc-btn vc-btn--primary vc-btn--medium vc-btn--full vc-btn--notfull--md-up"
      i18n="@@SELLER_BADGES.SECTION_1.BUTTON.NAME"
      (clicked)="trackSellButtonClick(trackingClickPositions.InpageBottom)"
    >
      Discover my stats
    </vc-ref>
  </section>
  ​
  <section class="sellerBadge__section" id="badge__benefits">
    <h2 class="sellerBadge__section__title vc-title-s" i18n="@@SELLER_BADGES.SECTION_2.TITLE">
      What are my benefits as a Trusted or Expert Seller?
    </h2>
    <table class="sellerBadge__table">
      <thead>
        <tr class="sellerBadge__table__head">
          <th class="sellerBadge__table__hcell">
            <h3 i18n="@@SELLER_BADGES.SECTION_2.TABLE.TITLE" class="vc-text-l sellerBadge__table__hcell--title">
              Badge benefits
            </h3>
          </th>
          <th class="sellerBadge__table__hcell">
            <vc-sprite-icons
              name="badge-trusted"
              class="sellerBadge__table__hcell__icon sellerBadge__table__hcell__icon--trusted"
            ></vc-sprite-icons>
          </th>
          <th class="sellerBadge__table__hcell">
            <vc-sprite-icons
              name="badge-expert"
              class="sellerBadge__table__hcell__icon sellerBadge__table__hcell__icon--expert"
            ></vc-sprite-icons>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr class="sellerBadge__table__row">
          <td
            class="sellerBadge__table__cell sellerBadge__table__cell--benefits"
            i18n="@@SELLER_BADGES.SECTION_2.TABLE.LINE_2.CELL_1"
          >
            Boosted visibility of your items
          </td>
          <td class="sellerBadge__table__cell sellerBadge__table__cell--trusted">+</td>
          <td class="sellerBadge__table__cell sellerBadge__table__cell--expert">++</td>
        </tr>
        <tr class="sellerBadge__table__row">
          <td
            class="sellerBadge__table__cell sellerBadge__table__cell--benefits"
            i18n="@@SELLER_BADGES.SECTION_2.TABLE.LINE_3.CELL_1"
          >
            Boosted visibility of your profile
          </td>
          <td class="sellerBadge__table__cell sellerBadge__table__cell--trusted">+</td>
          <td class="sellerBadge__table__cell sellerBadge__table__cell--expert">++</td>
        </tr>
      </tbody>
    </table>
    <p class="sellerBadge__section__paragraph" i18n="@@SELLER_BADGES.SECTION_2.PARAGRAPH_1">
      Start listing now to unlock your seller badge and stand out as one of the most active and trusted members of our
      community !
    </p>
  </section>
  ​
</div>
